import { render, staticRenderFns } from "./gisadd.vue?vue&type=template&id=8993e3aa&scoped=true"
import script from "./gisadd.vue?vue&type=script&lang=js"
export * from "./gisadd.vue?vue&type=script&lang=js"
import style0 from "./gisadd.vue?vue&type=style&index=0&id=8993e3aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8993e3aa",
  null
  
)

export default component.exports